import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { requestTwoVerification } from '@/store/slices/authSlice';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';

const RequestTwoVerification = () => {
  const [emailCode, setEmailCode] = useState('');
  const [phoneCode, setPhoneCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await dispatch(requestTwoVerification({ emailCode, phoneCode })).unwrap();
      setSuccess(true);
      setEmailCode('');
      setPhoneCode('');
    } catch (err) {
      setError(err.message || 'Failed to send verification code');
    } finally {
      setLoading(false);
    }
  };

  const handleCodeChange = (setter) => (e) => {
    const value = e.target.value.replace(/\D/g, ''); 
    if (value.length <= 6) {
      setter(value);
    }
  };

  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle className="text-2xl">Verify Your Account</CardTitle>
        <CardDescription style={{ marginBottom: '15px' }}>
          Enter the verification codes sent to your email and phone
        </CardDescription>
      </CardHeader>
      <CardContent>
        {error && (
          <Alert variant="destructive" className="mb-4">
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}

        {success && (
          <Alert className="mb-4">
            <AlertDescription>
              Verification successful!
            </AlertDescription>
          </Alert>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="emailCode">Email Code</Label>
            <Input
              id="emailCode"
              type="text"
              inputMode="numeric"
              pattern="\d{6}"
              maxLength={6}
              placeholder="Enter 6-digit code"
              value={emailCode}
              onChange={handleCodeChange(setEmailCode)}
              required
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="phoneCode">Phone Number Code</Label>
            <Input
              id="phoneCode"
              type="text"
              inputMode="numeric"
              pattern="\d{6}"
              maxLength={6}
              placeholder="Enter 6-digit code"
              value={phoneCode}
              onChange={handleCodeChange(setPhoneCode)}
              required
            />
          </div>

          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? 'Sending...' : 'Submit'}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default RequestTwoVerification;
